var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"14","cy":"14","r":"14","fill":"#162CA2"}}),_c('circle',{attrs:{"cx":"14.0002","cy":"13.9997","r":"4.66667","fill":"#FFDE59"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }